const EmailFormStyles = () => ({
  container: {
    flex: 1
  },
  tableRoot: {
    maxHeight: '400px'
  },
  gridItemFundName: {
    textOverflow: 'ellipsis'
  },
  disableStyleInput: {
    '& > div ': {
      backgroundColor: 'transparent',
      border: '0px',
      color: 'black !important',
      '& > input': {
        textOverflow: 'ellipsis'
      }
    },
    '& > :before': {
      display: 'none'
    }
  },
  dropZone: {
    background: '#ffffff',
    border: '1px dashed #E0E0E0'
  },
  removeButton: {
    textAlign: 'center',
    padding: '.5rem'
  },
  rootCell: {
    minWidth: '165px'
  },
  tableCell: {
    minWidth: '100px'
  },
  arrowGroupGridItem: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '4px'
  },
  selectAllItem: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '10px'
  },
  buttonItem: {
    flexDirection: 'column',
    marginBottom: '4px'
  },
  buttonClass: {
    backgroundColor: 'white',
    borderRadius: '2px',
    width: '100%',
    padding: '4px 0px 1px',
    marginTop: '6px',
    fontSize: '13px',
    border: '1px solid #E0E0E0',
    '&:hover': {
      backgroundColor: 'white',
      border: '1px solid #E0E0E0'
    }
  },
  labelCustom: {
    fontSize: '14px',
    color: '#757575',
    fontFamily: 'Segoe UI, Arial, sans-serif',
    fontWeight: '400'
  },
  root: {
    paddingTop: '5px',
    flexDirection: 'row-reverse',
    display: 'flex'
  },
  itemCollapsed: {
    color: '#212121',
    fontSize: '14px'
  },
  checkbox: {
    padding: '0',
    marginRight: '4px'
  },
  checkboxInvisible: {
    display: 'invisible'
  },
  formCheckBox: {
    display: 'flex'
  },
  ccCheckbox: {
    padding: '0',
    marginRight: '4px',
    marginLeft: '24px'
  },
  paper: {
    minWidth: '600px',
    '& > div': {
      maxHeight: '30vh'
    }
  },
  inputLabel: {
    width: '100%'
  },
  checkboxDiv: {
    marginTop: '25px'
  },
  tooltipPlacementBottom: {
    marginTop: '-10px'
  },
  loading: {
    height: 'calc(100vh - 230px)',
    width: 'calc(100vw - 32px)'
  }
});

export default EmailFormStyles;
